import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FileViews from '../../../constants/FileViews';
import InputSettingsField from './InputSettingsField';
import { StyledAddonBefore } from './SettingsCommonElements';

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledInputWrapper = styled.div`
  box-sizing: border-box;
  max-width: 50%;
`;

const PositionSettings = ({
  view,
  x,
  y,
  width,
  height,
  onChange
}) => {

  return (
    <>
      <StyledRow style={{ marginBottom: '8px' }}>
        {view === FileViews.mobile ? null : (
          <StyledInputWrapper style={{ paddingRight: '4px' }}>
            <InputSettingsField
              type="number"
              addonBefore={<StyledAddonBefore>X</StyledAddonBefore>}
              value={x}
              onChange={(i, value) => onChange('x', value ? parseFloat(value, 10) : 0)}
            />
          </StyledInputWrapper>
        )}
        <StyledInputWrapper>
          <InputSettingsField
            type="number"
            addonBefore={<StyledAddonBefore>Y</StyledAddonBefore>}
            value={y}
            onChange={(i, value) => onChange('y', value ? parseFloat(value, 10) : 0)}
          />
        </StyledInputWrapper>
      </StyledRow>
      <StyledRow>
        {view === FileViews.mobile ? null : (
          <StyledInputWrapper style={{ paddingRight: '4px' }}>
            <InputSettingsField
              type="number"
              addonBefore={<StyledAddonBefore>W</StyledAddonBefore>}
              value={width}
              onChange={(i, value) => onChange('width', value ? parseFloat(value, 10) : 1)}
            />
          </StyledInputWrapper>
        )}
        <StyledInputWrapper>
          <InputSettingsField
            type="number"
            addonBefore={<StyledAddonBefore>H</StyledAddonBefore>}
            value={height}
            onChange={(i, value) => onChange('height', value ? parseFloat(value, 10) : 1)}
          />
        </StyledInputWrapper>
      </StyledRow>
    </>
  );
};

PositionSettings.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  onChange: PropTypes.func
};

export default PositionSettings;
